module.exports = __webpack_public_path__ + "static/media/Panasonic.8e0a6427.png";